import React from 'react';
import '../styles/components.css';

const Card = ({ title, children, className = '', actions }) => {
    return (
        <div className={`card ${className}`}>
            {title && (
                <div className="card-header">
                    <h3>{title}</h3>
                    {actions && <div className="card-actions">{actions}</div>}
                </div>
            )}
            <div className="card-body">
                {children}
            </div>
        </div>
    );
};

export default Card;
